import React from "react";
import { cn } from "@/lib/utils";

const STAGE = {
  "To Do": "bg-blue-50 dark:bg-blue-950/60 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800",
  "Prepare": "bg-violet-50 dark:bg-violet-950/60 text-violet-700 dark:text-violet-300 border-violet-200 dark:border-violet-800",
  "Create": "bg-teal-50 dark:bg-teal-950/60 text-teal-700 dark:text-teal-300 border-teal-200 dark:border-teal-800",
  "Review": "bg-orange-50 dark:bg-orange-950/60 text-orange-700 dark:text-orange-300 border-orange-200 dark:border-orange-800",
  "Approval": "bg-amber-50 dark:bg-amber-950/60 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-800",
  "Complete": "bg-emerald-50 dark:bg-emerald-950/60 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800",
};

const STATUS = {
  "Completed": "bg-emerald-100 dark:bg-emerald-950 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800",
  "Source Link Missing": "bg-orange-100 dark:bg-orange-950 text-orange-800 dark:text-orange-300 border-orange-300 dark:border-orange-800",
  "Not Used": "bg-zinc-100 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-300 border-zinc-300 dark:border-zinc-700",
  "Rejected": "bg-rose-100 dark:bg-rose-950 text-rose-800 dark:text-rose-300 border-rose-300 dark:border-rose-800",
  "Cancelled": "bg-red-100 dark:bg-red-950 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800",
  "Internal Use": "bg-indigo-100 dark:bg-indigo-950 text-indigo-800 dark:text-indigo-300 border-indigo-300 dark:border-indigo-800",
  "Active": "bg-blue-100 dark:bg-blue-950 text-blue-800 dark:text-blue-300 border-blue-300 dark:border-blue-800",
};

const TYPE = {
  "Video": "bg-violet-500/10 text-violet-600 dark:text-violet-400 border-violet-500/20",
  "Poster": "bg-pink-500/10 text-pink-600 dark:text-pink-400 border-pink-500/20",
  "Reel": "bg-fuchsia-500/10 text-fuchsia-600 dark:text-fuchsia-400 border-fuchsia-500/20",
  "Graphic": "bg-sky-500/10 text-sky-600 dark:text-sky-400 border-sky-500/20",
  "Other": "bg-gray-500/10 text-gray-600 dark:text-gray-400 border-gray-500/20",
};

const base = "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap";

export function StagePill({ stage, className }) {
  if (!stage) return null;
  return <span className={cn(base, STAGE[stage] || STAGE["To Do"], className)}>{stage}</span>;
}

export function StatusPill({ status, className }) {
  if (!status) return null;
  return <span className={cn(base, STATUS[status] || STATUS["Never Used"], className)}>{status}</span>;
}

export function TypePill({ type, className }) {
  if (!type) return null;
  return <span className={cn(base, TYPE[type] || TYPE["Other"], className)}>{type}</span>;
}

export function ArchiveBadge({ archiveStatus, className }) {
  const archived = archiveStatus === "Completed";
  const style = archived
    ? "bg-emerald-100 dark:bg-emerald-950 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800"
    : "bg-amber-100 dark:bg-amber-950 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-800";
  return <span data-testid="archive-badge" className={cn(base, style, className)}>{archived ? "ARCHIVED" : "NOT FULLY ARCHIVED"}</span>;
}
